export const listingDetail = {
  breadcrumb: {
    listings: "Listings",
    detailFallback: "Detail",
  },
  hero: {
    noName: "No name",
    editNameTitle: "Edit name",
    channelConnected: "Connected to the channel (OTAs)",
    channelDisconnected: "Not connected to the channel",
  },
  units: {
    unitsCount: "{count} units",
    roomsCount: "{count} room | {count} rooms",
    maxGuests: "Max. {count} guests",
    searchPlaceholder: "Search unit…",
    dragTitle: "Drag to reorder",
    headerRoomTypes: "ROOM TYPES",
    headerLinkedUnits: "LINKED UNITS",
    addBtnTitle: "Add unit",
    movedBadge: "moved",
    unitFallback: "Unit",
  },
  typeLabels: {
    apartment: "Apartment",
    house: "House",
    villa: "Villa",
    hotel: "Hotel",
    room: "Room",
    studio: "Studio",
    fallback: "Accommodation",
  },
  aiReception: {
    title: "AI Reception",
  },
  toggles: {
    enableAgent: {
      label: "Enable AI agent",
      hint: "Automate guest support over WhatsApp.",
    },
    otaAgent: {
      label: "AI agent for OTAs",
      hintOn: "Also replies to messages from Booking, Airbnb and other OTAs.",
      hintOff: "Requires the AI agent to be active.",
    },
  },
  status: {
    active: "Active",
    inactive: "Inactive",
  },
  emptyUnits: {
    title: "No units",
    subHotel: "Create the first room or unit for this hotel to start setting up rates and availability.",
    subDefault: "Add the first unit to this listing to start receiving guests.",
    ctaPreparing: "Preparing…",
    ctaAddRoom: "Add room",
    ctaAddFirstUnit: "Add first unit",
  },
  sortBar: {
    add: "Add",
    addRoom: "Add room",
    saving: "Saving…",
    done: "Done",
    sort: "Reorder",
    dragHint: "Drag to reorder",
  },
  propOptions: {
    scheduled: "Scheduled messages",
    services: "Equipment and amenities",
    locks: "Locks",
    faq: "Q&A",
    arrival: "Arrival instructions",
    checkout: "Checkout message",
    welcome: "Welcome message",
    description: "Description",
    capacity: "Capacity",
  },
  addZone: {
    titleRoom: "Add room",
    titleUnit: "Add unit",
    roomLower: "room",
    unitLower: "unit",
    createNew: "Create a new {noun} inside",
    eachHas: "Each {noun} has its own settings (description, capacity, access…).",
    ctaPreparing: "Preparing…",
    ctaCreateRoom: "Create room",
    ctaCreateUnit: "Create unit",
  },
  danger: {
    deleteListing: "Delete listing...",
    notePrefix: "Deletes the listing",
    noteSuffix: " and all its units from WACheckin. This action cannot be undone.",
  },
  toast: {
    orderSaved: "Order saved successfully",
  },
  errors: {
    loadListing: "Could not load the accommodation.",
  },
  authorities: {
    title: "Authorities",
    description: "Set up the connection with local authorities for automatic guest registration reporting.",
  },
  cards: {
    knowledge: { title: "Knowledge base", status: "Information the agent uses" },
    earlyAccess: { title: "Early access", status: "Arrival times and early check-in" },
    lateCheckout: { title: "Late checkout", status: "Late checkout and price" },
    extendStay: { title: "Extend stay", status: "Extend the booking's nights" },
    invoicing: { title: "Invoicing", status: "Tax details · Verifactu friendly" },
    location: { title: "Location", sub: "Accommodation address" },
    logo: { title: "Branding", sub: "Visual identity" },
    welcome: { title: "Welcome message", sub: "Customize the welcome" },
    checkin: { title: "Check-in", sub: "Entry instructions and schedule" },
    policies: { title: "Accommodation policies", sub: "Rules and conditions" },
    authorities: { sub: "Registration with authorities" },
    hotelRates: { title: "Hotel rates", sub: "Base and derived rates" },
    roomManagement: { title: "Rooms", sub: "Room types and inventory" },
    rates: { title: "Rates", sub: "Base and derived rates" },
    ota: { title: "Connect OTA", subPaid: "Booking · Airbnb · Vrbo · Expedia", subUnpaid: "Requires an active subscription" },
    ical: { title: "iCal Calendar", sub: "Calendar synchronization" },
    ownerSettlement: { title: "Owner & settlement", sub: "If you manage it for another owner: commission and settlement", subManaged: "Managed for {owner} · {pct}%", subManagedNoOwner: "Managed · {pct}% · no owner assigned" },
    otaCommissions: { title: "OTA commissions", sub: "What each OTA keeps and what you receive", subActive: "Reservations show what you actually receive" },
    description: { title: "Description", sub: "Unit details" },
    capacity: { title: "Capacity", sub: "Guests and beds" },
    services: { title: "Equipment and amenities", sub: "What it offers, with photos" },
    unitFaq: { title: "Q&A", sub: "Specific to this unit for the agent" },
    rules: { title: "Schedule", sub: "Check-in and check-out times" },
    upselling: { title: "Experiences and services", sub: "Upselling services" },
    checkinStore: { title: "Check-in store", sub: "Send it to the guest on arrival" },
    bookingConfirmation: { title: "Notify new booking", sub: "We notify the guest on WhatsApp when their booking is confirmed" },
    arrivalInstructions: { title: "Arrival instructions", sub: "How to get there and get in · with send time" },
    checkoutMessage: { title: "Checkout message", sub: "Checkout reminder · template" },
    scheduledMessages: { title: "Scheduled messages", sub: "Automatic messages before, during and after the stay" },
    review: { title: "Request review", sub: "Accommodation reputation" },
    identity: { title: "Identity verification", sub: "Guest security" },
    journeySim: { title: "Simulate guest journey", sub: "Replays the whole process on WhatsApp · send it to a phone to test" },
    smartlocks: { title: "Locks and access", sub: "How the guest gets in" },
    integrations: { title: "Connections and integrations", sub: "Additional APIs and connections" },
    welcomeInline: { sub: "Message specific to this unit" },
    newBookings: { title: "New bookings" },
  },
  badges: {
    ai: "AI",
    setup: "Setup",
    hotel: "Hotel",
    subscription: "Subscription",
    comingSoon: "Coming soon",
    test: "Test",
    manager: "Manager",
    active: "Active",
  },
  sections: {
    essential: { title: "Essential setup", description: "Basic settings needed to publish and manage the accommodation." },
    management: { title: "Accommodation management", description: "Set up rates, availability and sales channels." },
    direct: { title: "Detail this unit", description: "Additional information we use for direct bookings and to feed the AI Agent." },
    guest: { title: "Guest experience", description: "Set up communication before, during and after the stay." },
    access: { title: "Access and integrations", description: "Manage access, locks and external connections." },
  },
  otaModal: {
    title: "OTA connection",
    html: "Connecting Booking, Airbnb, Vrbo, Expedia (channel manager) requires an <b>active subscription</b>.<br><small>In the meantime you can use the rest of the features and sync calendars via iCal (free).</small>",
    confirm: "Activate subscription",
    cancel: "Not now",
  },
};
